import { IRegions } from '../types';

export const CHANGE_DICTIONARY_REGIONS = 'DICTIONARIES :: CHANGE_REGIONS';

export type TChangeDictionaryRegionsAction = {
  type: typeof CHANGE_DICTIONARY_REGIONS;
  payload: IRegions;
};

export function changeDictionaryRegions(payload: IRegions): TChangeDictionaryRegionsAction {
  return {
    type: CHANGE_DICTIONARY_REGIONS,
    payload,
  };
}
